import { useTranslation } from "react-i18next";
import Wallet from "lucide-react/dist/esm/icons/wallet.js";
import { cn } from "@shared/lib/utils";
import { useWallet } from "../../../hooks/useWallet";
import { PaywallGate } from "@shared/components/paywall";
import { localizedPaymentPath } from "../../../utils/localizedRoutes";

export interface WalletBalanceBadgeProps {
  locale?: string;
  className?: string;
}

function WalletBadgeInner({ locale, className }: WalletBalanceBadgeProps) {
  const { i18n } = useTranslation("payment");
  const { data: wallet, isLoading } = useWallet();

  if (isLoading || !wallet) return null;

  const effectiveLocale = locale ?? i18n.language ?? "en-US";
  const formatted = new Intl.NumberFormat(effectiveLocale, {
    style: "currency",
    currency: wallet.currency,
  }).format(wallet.balanceCents / 100);

  const isLow = wallet.balanceCents < wallet.lowBalanceThresholdCents;

  return (
    <a
      href={localizedPaymentPath("/wallet")}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5",
        "bg-muted text-muted-foreground hover:bg-muted/80 transition-colors",
        "text-sm font-medium",
        isLow && "motion-safe:animate-pulse",
        className
      )}
    >
      <Wallet className="h-4 w-4" />
      <span>{formatted}</span>
    </a>
  );
}

export function WalletBalanceBadge(props: WalletBalanceBadgeProps) {
  return (
    <PaywallGate>
      <WalletBadgeInner {...props} />
    </PaywallGate>
  );
}
